<template>
  <core-modal
    @close="closeModal"
    :stateOpen="isOpen"
    containerStyle="width: 40%"
  >
    <div slot="header" class="p-3 text-uppercase">
      {{ $t('reservation.cancel-booking') }}
    </div>
    <div slot="body">
      {{ $t('reservation.paid-cancel-booking') }}
    </div>
    <div slot="footer">
      <button
        type="button"
        @click="cancelReservationLine"
        class="btn btn-primary rounded m-0"
      >
        {{ $t('general.yes') }}
      </button>
      <button
        type="button"
        @click="closeModal"
        class="btn btn-primary rounded m-0"
      >
        {{ $t('general.no') }}
      </button>
    </div>
  </core-modal>
</template>

<script>

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    cancelReservationLine () {
      this.$emit('cancelBooking')
      this.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/CancelBookingModal.vue